import WatchButtonContainer from './WatchButton.container';
import WatchButton from './WatchButton';
export * from './WatchButton';
import * as WatchButtonActionCreators from './actionCreators';
import watchButtonReducers from './reducers';
import watchButtonSaga from './saga';
export default WatchButtonContainer(WatchButton);
export { watchButtonReducers, watchButtonSaga, WatchButtonActionCreators };
export * from './types';
//# sourceMappingURL=index.js.map